import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import useHandleError from '@/hooks/useHandleError';
import { selectedOrganizationAtom } from '@/pages/Organizations';

import type { DownloadsResponse } from './AdministrationDownloads.types';

export const useFetchDownloads = (type: 'images' | 'log_agents') => {
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const handleError = useHandleError();

  const { data, error, isError, isFetching } = useQuery<
    DownloadsResponse,
    AxiosError
  >({
    queryKey: [`organizations/${selectedOrganization.label}/${type}`],
    staleTime: Infinity,
    enabled: selectedOrganization?.label !== 'all' // do not fetch if all organizations are selected
  });

  useEffect(() => {
    if (isError) {
      handleError(error, `Failure to fetch ${type} downloads.`);
    }
  }, [isError]);

  return { data, isFetching };
};

export default useFetchDownloads;
